module.exports = __webpack_public_path__ + "static/columnPinning-8abce980f04adcf436cf872eba9041a8.gif";